import { useEffect, useState } from "react";
import debounce from "@mui/utils/debounce";
import { Breakpoint, Theme, useTheme } from "@mui/material";
import { colors } from "../styles/theme";

type DebugData = {
  width: number;
  height: number;
  breakpoint: Breakpoint;
};

export function getBreakpointName(theme: Theme, width: number): Breakpoint {
  const { keys, values } = theme.breakpoints;

  let current: Breakpoint = keys[0];

  keys.forEach((key) => {
    const bpValue = values[key];
    if (width >= bpValue) {
      current = key;
    }
  });

  return current;
}

export function useDebugData(props: { debounceMs?: number, applyGlobalStyles?: boolean } = {}): DebugData {
  const { debounceMs = 200, applyGlobalStyles = false } = props
  const theme = useTheme();
  const getData = () => ({
    width: window.innerWidth,
    height: window.innerHeight,
    breakpoint: getBreakpointName(theme, window.innerWidth),
  });

  const [data, setData] = useState<DebugData>(() => {
    if (typeof window === "undefined") {
      return { width: 0, height: 0, breakpoint: 'xs', }
    }
    return getData();
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => setData(getData());
    const debouncedResize = debounce(handleResize, debounceMs);
    debouncedResize();
    window.addEventListener("resize", debouncedResize);
    return () => {
      window.removeEventListener("resize", debouncedResize);
      debouncedResize.clear();
    };
  }, [debounceMs]);

  useEffect(() => {
    if (applyGlobalStyles) {
      document.querySelectorAll('html, body').forEach(el => {
        /* @ts-ignore */
        el.classList.add('global-containers-styles');
      })
    }
  }, [applyGlobalStyles]);

  return data;
}
